import { PreviewPaneMode } from 'owa-sxsdata';

const supportedPreviewTypes = [PreviewPaneMode.Image];

export function isFullScreenAvailable(previewType: PreviewPaneMode): boolean {
    if (supportedPreviewTypes.indexOf(previewType) == -1) {
        return false;
    }

    const element = document.createElement('div');
    return !!getRequestFullScreenMethod(element);
}

export function requestFullScreen(element: HTMLElement) {
    const requestMethod = getRequestFullScreenMethod(element);
    if (requestMethod) {
        requestMethod.call(element);
    }
}

function getRequestFullScreenMethod(element: any): () => void {
    if (element) {
        return (
            element.requestFullscreen ||
            element.msRequestFullscreen ||
            element.webkitRequestFullscreen ||
            element.mozRequestFullScreen
        );
    }

    return null;
}

export function exitFullScreen() {
    const doc: any = document;
    if (document.exitFullscreen) {
        document.exitFullscreen();
    } else if (doc.msExitFullscreen) {
        doc.msExitFullscreen();
    } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
    } else if (doc.mozCancelFullScreen) {
        doc.mozCancelFullScreen();
    }
}
